import { render, staticRenderFns } from "./LBtn.vue?vue&type=template&id=7ad6da21"
var script = {}
import style0 from "./LBtn.vue?vue&type=style&index=0&id=7ad6da21&prod&lang=sass"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports